import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "requireDisclaimerCheckbox",
    "limitAccessCheckbox",
    "disclaimerContainer",
    "accessToEbooksContainer",
    // Custom Identifier
    'requireCustomIdentifierCheckbox',
    'identifierPatternContainer',
    'identifierPatternInput'
  ]

  connect() {
    // Initialize visibility on page load
    this.toggleDisclaimerContainer()
    this.toggleAccessToEbooksContainer()
    this.toggleRequireCustomIdentifier()
  }

  toggleDisclaimer() {
    this.toggleDisclaimerContainer()
  }

  toggleLimitAccess() {
    this.toggleAccessToEbooksContainer()
  }

  toggleDisclaimerContainer() {
    if (this.hasRequireDisclaimerCheckboxTarget && this.hasDisclaimerContainerTarget) {
      const isChecked = this.requireDisclaimerCheckboxTarget.checked

      if (isChecked) {
        this.disclaimerContainerTarget.classList.remove('d-none')
      } else {
        this.disclaimerContainerTarget.classList.add('d-none')
      }
    }
  }

  toggleAccessToEbooksContainer() {
    if (this.hasLimitAccessCheckboxTarget && this.hasAccessToEbooksContainerTarget) {
      const isChecked = this.limitAccessCheckboxTarget.checked

      if (isChecked) {
        this.accessToEbooksContainerTarget.classList.remove('d-none')
      } else {
        this.accessToEbooksContainerTarget.classList.add('d-none')
      }
    }
  }

  toggleRequireCustomIdentifier() {
    if (this.hasRequireCustomIdentifierCheckboxTarget && this.hasIdentifierPatternContainerTarget) {
      const isChecked = this.requireCustomIdentifierCheckboxTarget.checked

      if (isChecked) {
        this.identifierPatternContainerTarget.classList.remove('d-none')
      } else {
        this.identifierPatternContainerTarget.classList.add('d-none')
        // Clear the input value when hidden
        if (this.hasIdentifierPatternInputTarget) {
          this.identifierPatternInputTarget.value = ''
        }
      }
    }
  }
}